<template>
  <b-container>
    <div class="d-flex flex-row-reverse">
      <b-button size="sm"  @click="goBack()" class="mt-3">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>

      </b-button>
    </div>
    <TicketActivity :activity="activity" :ticket="ticket" class="mb-2 mt-2"/>

    <b-card v-show="ticket.estatus != 'Cerrado'" class=" shadow mb-2 mt-2 bg-white rounded" :title="'Ticket #'+ticket.id ">
      <b-card-body>
      
          <b-form-group id="input-group-2" label="Comentario:" label-for="comentario">
            <!--
            <b-form-input id="comentario" v-model="dataform.descripcion" name="comentario" v-validate="'required|min:2 '"
              :state="validateState('comentario')" placeholder="Escriba el comentario del ticket"></b-form-input>

            <b-form-invalid-feedback>
              {{ errors.first('comentario') }}
            </b-form-invalid-feedback>
            -->  

            <b-form-textarea
              id="comentario"
              name="comentario"
              v-model="dataform.descripcion"
              placeholder="Escriba el comentario del ticket"
              rows="5"
              max-rows="8"
              v-validate="'required|min:5 '"
              :state="validateState('comentario')" 

            ></b-form-textarea>
            <b-form-invalid-feedback>
              {{ errors.first('comentario') }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="input-group-3"
            label="Estado:"
            label-for="Estado">

            <b-form-select
              v-model="dataform.estado"
              :options="options">
            </b-form-select>

          </b-form-group>
          
          
  
      </b-card-body>
      
    </b-card>

    <b-card v-show="ticket.estatus != 'Cerrado'"  class=" shadow p-3 mb-2 mt-2 bg-white rounded" title="Subir imagenes al ticket" sub-title="Las imagenes se suben independientemente del estado del ticket">
      <TicketImage :ticketid="ticket.id" class="mt-4" />
    </b-card>
    
    <b-button  
      v-show="ticket.estatus != 'Cerrado'"   
      :disabled="errors.any()" 
      @click="onSubmit"
      variant="primary" 
      class="mb-5"
    >
      Enviar
    </b-button>

  </b-container>
</template>

<script>
  import {mapState,mapActions} from 'vuex'

  import validateMixin from '@/mixins/validation'
  import TicketImage from '@/components/tickets/TicketImage'
  import TicketActivity from '@/components/tickets/TicketActivity.vue'



  export default {
    components:{
      TicketImage,
      TicketActivity,
    }, 
    mixins : [validateMixin],
    data: function(){
      return{
        dataform:{
          ticket_id:'',
          user_id:'',
          descripcion:'',
          estado: '',
        },
        options:[],
      }
    },
    mounted(){this.init()},
    computed:{
      //variable del state que tiene el id del login.
      ...mapState('login',['id']),
      ...mapState('etiquetas',['estados']),
      ...mapState('ticket',['ticket','activity','isOk']),
      },//computed  
    methods:{
      ...mapActions({
      _fetchEstados: 'etiquetas/fetchEstados',
      _crearActividad: 'ticket/crearActividad',

      }),

      init(){
        this._fetchEstados().then(()=>{
          let that = this//dentro del foreach no usar this.
          this.estados.forEach(function(value){
            if ((value.nombre != "Cerrado")  ){
                let payload = {
                value: value.id,
                text:  value.nombre
              } 
              if(that.ticket.estatus == value.nombre){
                that.dataform.estado = value.id
              }
              that.options.push(payload)
              
            }
          })
        })

        this.dataform.user_id = this.id
        this.dataform.ticket_id = this.ticket.id
       
        
        if (this.dataform.ticket_id === undefined){
          this.goBack()
        }
      },//init()
      goBack() {
        this.$router.go(-1)
      },
      async onSubmit(evt){
        evt.preventDefault()
        const validate = await this.$validator.validateAll()
        if(!validate) {return false}
        
        let payload = {
          'ticket_id': this.dataform.ticket_id,
          'user_id': this.dataform.user_id,
          'descripcion' : this.dataform.descripcion,
          'estado' : this.dataform.estado
        } 
        this._crearActividad(payload).then(()=>{
           if(this.isOk){
		    			    this.$toasted.show('La actividad se guardo correctamente', { 
	 	    						theme: "bubble", 
	 	    						position: "top-right", 
	 	    						duration : 3000
                            })
                       
                        // volvemos a la pagina anterior
                        this.$router.go(-1) 
                    }else{
                        this.$toasted.show('Error al guardar la actividad del ticket', { 
                  				duration : 3000
                          })
            }  
        })
      },

      

    },
  }
</script>

<style lang="scss" scoped>

</style>